<template>
  <div class="flex w-full">
    <component :is="'script'" src="https://cdn.candu.ai/sdk/latest/candu.umd.js"></component>
    <component :is="'script'">
      setTimeout(() => {
        Candu.init({
          clientToken: '{{canduToken}}'
        });
      }, 1000);
    </component>
    <div id="canduLoginPage"></div>
  </div>
</template>

<script>
export default {
  name: 'candu',
  data () {
    return {
      canduToken: 'e4OTHIYCyk'
    }
  }
}
</script>

<style scoped>
#canduLoginPage {
  width: 100%;
}
</style>
